import { TFunction } from 'i18next';

export const mapFromEnum = (en: any, t?: TFunction) => Object.values(en).map((v: any) => ({
  value: v,
  label: t ? t(v) : v,
}));

export const arrayFromEnum = (en: any) => mapFromEnum(en).map(s => s.value);